import isEqual from 'lodash/isEqual';

import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import { isMailingAddressComplete, normalizeMailingAddress } from '../../util/mailingAddress';
import { currentUserShowSuccess, fetchCurrentUser } from '../../ducks/user.duck';

export const SAVE_MAILING_ADDRESS_REQUEST = 'app/MailingAddressPage/SAVE_MAILING_ADDRESS_REQUEST';
export const SAVE_MAILING_ADDRESS_SUCCESS = 'app/MailingAddressPage/SAVE_MAILING_ADDRESS_SUCCESS';
export const SAVE_MAILING_ADDRESS_ERROR = 'app/MailingAddressPage/SAVE_MAILING_ADDRESS_ERROR';
export const SAVE_MAILING_ADDRESS_CLEAR = 'app/MailingAddressPage/SAVE_MAILING_ADDRESS_CLEAR';

const initialState = {
  mailingAddressChanged: false,
  saveMailingAddressError: null,
  saveMailingAddressInProgress: false,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case SAVE_MAILING_ADDRESS_REQUEST:
      return {
        ...state,
        mailingAddressChanged: false,
        saveMailingAddressError: null,
        saveMailingAddressInProgress: true,
      };
    case SAVE_MAILING_ADDRESS_SUCCESS:
      return {
        ...state,
        mailingAddressChanged: true,
        saveMailingAddressInProgress: false,
      };
    case SAVE_MAILING_ADDRESS_ERROR:
      return {
        ...state,
        saveMailingAddressError: payload,
        saveMailingAddressInProgress: false,
      };
    case SAVE_MAILING_ADDRESS_CLEAR:
      return { ...initialState };
    default:
      return state;
  }
}

export const saveMailingAddressRequest = () => ({ type: SAVE_MAILING_ADDRESS_REQUEST });
export const saveMailingAddressSuccess = () => ({ type: SAVE_MAILING_ADDRESS_SUCCESS });
export const saveMailingAddressError = error => ({
  type: SAVE_MAILING_ADDRESS_ERROR,
  payload: error,
  error: true,
});
export const saveMailingAddressClear = () => ({ type: SAVE_MAILING_ADDRESS_CLEAR });

/**
 * Save a normalized mailing address without replacing other private profile data.
 */
export const saveMailingAddress = params => (dispatch, getState, sdk) => {
  dispatch(saveMailingAddressRequest());

  const { mailingAddress, currentMailingAddress, currentPrivateData = {} } = params;
  const normalizedMailingAddress = normalizeMailingAddress(mailingAddress);
  const mailingAddressHasChanged = !isEqual(
    normalizedMailingAddress,
    normalizeMailingAddress(currentMailingAddress)
  );

  if (!mailingAddressHasChanged || !isMailingAddressComplete(normalizedMailingAddress)) {
    dispatch(saveMailingAddressError(storableError(new Error('Invalid mailing address'))));
    return Promise.resolve(null);
  }

  return sdk.currentUser
    .updateProfile(
      {
        privateData: {
          ...currentPrivateData,
          mailingAddress: normalizedMailingAddress,
        },
      },
      {
        expand: true,
        include: ['profileImage'],
        'fields.image': ['variants.square-small', 'variants.square-small2x'],
      }
    )
    .then(response => {
      const entities = denormalisedResponseEntities(response);
      if (entities.length !== 1) {
        throw new Error('Expected a resource in the sdk.currentUser.updateProfile response');
      }

      const currentUser = entities[0];
      dispatch(currentUserShowSuccess(currentUser));
      dispatch(saveMailingAddressSuccess());
      return currentUser;
    })
    .catch(error => {
      dispatch(saveMailingAddressError(storableError(error)));
      return null;
    });
};

export const loadData = () => fetchCurrentUser();
